import { config } from '../../config';
import { getLogger } from '../../services/logger';
import { request } from '../../utils';

import type { Provider } from '../../types';

const logger = getLogger('requestBlend');

const { baseUrl, providers } = config.curate.blendApi;

export type CurateFetchParams = {
  blendId: string;
};

export async function requestBlend<T = never>({
  provider,
  params,
  signal,
}: {
  provider: Provider;
  params?: CurateFetchParams;
  signal?: AbortSignal;
}) {
  const { site, context } = providers[provider]!;
  const url = new URL(baseUrl);
  const searchParams = new URLSearchParams({
    site,
    context,
  });

  if (params?.blendId) {
    searchParams.append('blendId', params.blendId);
  }

  url.search = searchParams.toString();

  try {
    const response = await request<T>(url, { signal });

    return await response.json();
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      throw error;
    }
    logger.error('Blend request failed', { provider, error });
    throw error;
  }
}
